site.sideContent = {
	init: function () {
		var $sideContent = $('#sideContent');
		if ($sideContent.length === 0) {
			return false;
		}

		$sideContent.append('<div class="wrapper" />');
		$('.wrapper', $sideContent)
			.on('click', function(e) {
				e.stopPropagation();
			})
			.append('<button class="close" aria-label="Close" />')
			.append('<div class="content" />')
		;

		var $body = $('body');
		$('.close', $sideContent).on('click', function(e) {
			$body.removeClass('sideContent-open');
		});

		// Close side content on body click, outside side content area
		$body.click(function (e) {
			if ($body.hasClass('sideContent-open')) {
				$body.removeClass('sideContent-open');
			}
		});

		// Close side content if escape key is pressed
		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				if ($body.hasClass('sideContent-open')) {
					$body.removeClass('sideContent-open');
				}
			}
		});

		$('a.sideContent').on('click', function(e) {
			var $this = $(this),
				directUrl = $this.data('direct')
			;
			if (directUrl) {
				e.preventDefault();

				$.ajax({
					type: 'GET',
					url: directUrl,
					dataType: 'html',
					success: function(data) {
						$('.content', $sideContent).empty().append(data);
						$body.addClass('sideContent-open');
					}
				});
			}
		});
	}
};

site.inits.push('site.sideContent.init()');